import Swagger from 'swagger-client';
import User from '../services/User';

export default {
  client: null,
  loadingClient: null,
  options: {
    url: '/specs/luminary-api.json',
    scheme: 'https',
    requestInterceptor: async (req) => {
      const userProvider = new User();
      const token = await userProvider.getUserToken();
      userProvider.setUserToken(token);

      req.headers = req.headers || {};
      req.headers['X-Id-Token'] = token;

      let { url } = req;
      if (url.indexOf('localhost:') > -1 && url.indexOf('https') > -1) {
        url = req.url.replace('https', 'http');
      } else if (url.indexOf('localhost:') < 0 && url.indexOf('https') < 0) {
        url = req.url.replace('http', 'https');
      }
      req.url = url;
    },
    responseInterceptor: () => {
      // console.log('res', res)
    },
  },

  getClient() {
    if (this.loadingClient) {
      return this.loadingClient;
    }
    this.loadingClient = new Promise((resolve, reject) => {
      if (this.client) {
        resolve(this.client);
      } else {
        Swagger(this.options).then((_client) => {
          const client = _client;
          client.http.withCredentials = false;
          // client.http.withCredentials = false;
          this.client = client;
          // console.log('client', client)
          resolve(client);
        }).catch((error) => {
          reject(error);
        });
      }
    });
    return this.loadingClient;
  },
};



// WEBPACK FOOTER //
// ./app/src/shared/swagger.js